import { c as _c } from "react/compiler-runtime";
import type { SOCIAL_MEDIA_ACCOUNT_STATEMENT_TYPE } from "@/helpers/Types";
import { SOCIAL_MEDIA_ACCOUNT_STATEMENT_TYPES } from "@/helpers/Types";
import UserPageIdentityAddStatementsTypeButton from "@/components/user/identity/statements/utils/UserPageIdentityAddStatementsTypeButton";
export default function UserPageIdentityAddStatementsSocialMediaAccountItems(t0) {
  const $ = _c(17);
  const {
    activeType,
    setSocialType
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== activeType || $[1] !== setSocialType) {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = (SOCIAL_MEDIA_ACCOUNT_STATEMENT_TYPES.length / 2).toFixed(0);
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    const firstRow = SOCIAL_MEDIA_ACCOUNT_STATEMENT_TYPES.slice(0, +t5);
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = (SOCIAL_MEDIA_ACCOUNT_STATEMENT_TYPES.length / 2).toFixed(0);
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    const secondRow = SOCIAL_MEDIA_ACCOUNT_STATEMENT_TYPES.slice(+t6);
    t3 = "tw-mt-8";
    const t7 = firstRow.map((type, i) => <UserPageIdentityAddStatementsTypeButton key={type} statementType={type} isActive={activeType === type} isFirst={i === 0} isLast={i === firstRow.length - 1} onClick={() => setSocialType(type)} />);
    if ($[8] !== t7) {
      t4 = <span className="tw-isolate tw-inline-flex tw-rounded-md tw-shadow-sm tw-w-full">{t7}</span>;
      $[8] = t7;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t1 = "tw-mt-3 md:tw-mt-2 tw-isolate tw-inline-flex tw-rounded-md tw-shadow-sm tw-w-full";
    t2 = secondRow.map((type_0, i_0) => <UserPageIdentityAddStatementsTypeButton key={type_0} statementType={type_0} isActive={activeType === type_0} isFirst={i_0 === 0} isLast={i_0 === secondRow.length - 1} onClick={() => setSocialType(type_0)} />);
    $[0] = activeType;
    $[1] = setSocialType;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2) {
    t5 = <span className={t1}>{t2}</span>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}